import styled from 'styled-components'

import { Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Title = styled(Heading2)`
font-size: 16px
  text-align: center;
`

export const Subtitle = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  line-height: 22px;
  margin: auto;
  max-width: 450px;
  text-align: center;
`

export const FinePrint = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  line-height: 16px;
  margin-top: 10px;
  text-align: center;
`

export const GraphContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  margin: 30px auto 50px;
  flex-direction: column;
`
